import { render, staticRenderFns } from "./DesktopNewSkeleton.vue?vue&type=template&id=d0289d28&scoped=true&"
var script = {}
import style0 from "./DesktopNewSkeleton.vue?vue&type=style&index=0&id=d0289d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0289d28",
  null
  
)

export default component.exports